import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {MdEdit} from "react-icons/md";
import {
    Table,
    TextInput,
    Button
} from "components";
import {relationshipTypeAction} from "redux/actions";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {adminTokenDev} from "../../../helper";
import axios from "axios";
import {DEV_APIS_URL} from "../../../configurations";
import AddRelationshipType from "./AddRelationshipType";
import UpdateRelationshipType from "./UpdateRelationshipType";

export default function RelationshipTypePanel() {

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [status, setStatus] = useState();
    const [filtername, setFiltername] = useState('');
    const [filterdesc, setFilterdesc] = useState('');
    const [editableDetails, setEditableDetails] = useState({});
    const [updateStatus, setUpdateStatus] = useState(false);
    const [datarefresh, setDatarefresh] = useState(false);

    // Redux actions
    const dispatch = useDispatch();
    const {customers, relationshiptypes, userRole} = useSelector(state => ({
        customers: state.customers,
        relationshiptypes: state.relationshipType,
        userRole: state.userRole?.filter(role => role.module === "Relationship Types")
    }));

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(relationshipTypeAction.get());        
        return () => dispatch(relationshipTypeAction.reset());
    }, [updateStatus,datarefresh]);

    useEffect(() => {
        if (!relationshiptypes?.length) {
            setTableRows();
            return;
        }

        let filtered = [...relationshiptypes].sort((a, b) =>
            a.relationship_name.localeCompare(b.relationship_name)
          ); //relationshiptypes;
        if (filtername) {
            filtered = filtered?.filter(data => data.relationship_name.toLowerCase() == filtername.toLowerCase());
        }

        if (filterdesc) {
            filtered = filtered?.filter(data => data.description.toLowerCase() == filterdesc.toLowerCase());
        }

        let newData = [];
       
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                userId: obj?.id,
                relationship_name: obj?.relationship_name,
                description: obj?.description,
                edit: (
                        <MdEdit
                            size="20"
                            color="#528ff0"
                            onClick={
                                () => {
                                    setEditableDetails(obj);
                                    setUpdateStatus(true);
                                }
                            }
                            className="clickable"
                        />
                    ),
                action: (
                    <Button
                        title={'Delete'}
                        style={{"padding":"0 0", "width": "55px"}}
                        onClick={
                            () => {
                                if (window.confirm("Are you sure you want to delete this item?")) {
                                    dispatch(relationshipTypeAction.deletedata({ id: obj?.id }));
                                    setDatarefresh(Math.random());
                                }
                            }
                        }
                    />
                )
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [relationshiptypes,filtername, status, filterdesc]);

    
    const setCreateStatus = () => {
        setUpdateStatus(false);
    }

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Si.No",
                sortBy: "userId"
            },
            {
                title: "Relationship Name",
                sortBy: "relationship_name"
            },
            {
                title: "Relationship Description",
                sortBy: "description"
            },
            {
                title: "Edit"
            },
            {
                title: "Delete"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        adminTokenDev()
            .then(token =>
                axios.get(
                    `${DEV_APIS_URL}/relationship-types`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ).then((response) => {
                        const rows = response.data.map(item => {
                            return {
                                "Id": item.id,
                                "Relationship Name": item.relationship_name,
                                "Description": item.description
                            }
                        })

                        const worksheet = XLSX.utils.json_to_sheet(rows);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                        XLSX.writeFile(workbook, "Relationship-Types-Datas.xlsx");
                    }
                )
            )
    }

    return (
        <div>
            <div className="row">
                <div className="col-sm-6">
                    <div className={styles.filter}>
                        <TextInput
                            label=""
                            placeholder="Filter By Name"
                            name="search"
                            onChange={e => setFiltername(e.target.value)}
                            value={filtername}
                        />
        
                        <TextInput
                            label=""
                            placeholder="Filter By Description"
                            name="search"
                            onChange={e => setFilterdesc(e.target.value)}
                            value={filterdesc}
                        />
                        
                        <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                                onClick={exportDataFunc}
                        >Export
                        </button>
                    </div>

                    <Table
                        headers={tableHeaders}
                        data={tableRows}
                        current={relationshiptypes?.pageNumber}
                        totalPage={Math.ceil(relationshiptypes?.count / 10)}
                        state={relationshiptypes}
                        length={tableRows?.length}
                        r_length={relationshiptypes?.users?.length}
                        t_length={relationshiptypes?.count}
                        exportData={false}
                    />
                    
                </div>
                <div className="col-sm-6" style={{marginTop: "66px", paddingLeft: "35px", borderLeft: "1px solid #44444466"}}>
                    {(updateStatus === true)?<UpdateRelationshipType editableDetails={editableDetails} onUpdate={setCreateStatus}/>:<AddRelationshipType status={setStatus} />}
                </div>
            </div>
        </div>
    );
}
